export const shopifyDiscountsCopy = {
  heading: 'Store discounts',
  description: 'Every discount in your Shopify store, read-only. Manage them in Shopify.',
  openInShopify: 'Open in Shopify',
  viewInShopify: 'View in Shopify',
  newTab: '(opens in a new tab)',
  columns: {
    title: 'Title',
    codes: 'Code(s)',
    type: 'Type / Value',
    status: 'Status',
    uses: 'Uses',
    dates: 'Dates',
    actions: 'Actions',
  },
  status: { ACTIVE: 'Active', SCHEDULED: 'Scheduled', EXPIRED: 'Expired' },
  automatic: 'Automatic',
  discovrBadge: 'Discovr',
  noValue: '-',
  moreCodes: (shown: number, total: number) => `+${total - shown} more`,
  dates: (start: string | null, end: string | null) => {
    if (start && end) return `${start} - ${end}`;
    if (start) return `From ${start}`;
    if (end) return `Until ${end}`;
    return '-';
  },
  filters: {
    searchLabel: 'Search discounts',
    searchPlaceholder: 'Search by title or code…',
    statusTabs: 'Filter by status',
    all: 'All',
    allTypes: 'All types',
    allMethods: 'All methods',
    allSources: 'All sources',
    status: { active: 'Active', scheduled: 'Scheduled', expired: 'Expired' },
    typeLabel: 'Type',
    type: {
      amount_off_products: 'Amount off products',
      amount_off_order: 'Amount off order',
      bxgy: 'Buy X get Y',
      free_shipping: 'Free shipping',
    },
    methodLabel: 'Method',
    method: { code: 'Code', automatic: 'Automatic' },
    sourceLabel: 'Source',
    source: { discovr: 'Discovr', other: 'Other' },
    clear: 'Clear filters',
  },
  typeValue: {
    buyXGetY: 'Buy X get Y',
    freeShipping: 'Free shipping',
    products: 'products',
    order: 'order',
    off: (amount: string, target: string) => `${amount} off ${target}`,
  },
  empty: 'No discounts in this store yet.',
  emptyFiltered: 'No discounts match these filters',
  emptyFilteredBody: 'Try a different term or clear the filters.',
  loadError: 'Couldn’t load your store discounts. Try again shortly.',
  retry: 'Try again',
  noneLoadedYet: 'No matches in the discounts loaded so far.',
  resultCount: (n: number, hasMore: boolean) => {
    if (hasMore) return `${n} shown`;
    return n === 1 ? '1 discount' : `${n} discounts`;
  },
  loadMore: 'Load more',
  loadingMore: 'Loading…',
};
